<template>
  <div>
    <NavComponent :index="4"></NavComponent>
    <SideBarComponent></SideBarComponent>
    <div class="banner" v-bind:style="{backgroundImage:'url(https://cdn.hanlandglobal.com/contcat-banner.jpg)'}">

    </div>
    <div class="content-container contact">
      <div class="title">
        <h3>联系我们</h3>
        <p>CONTACT US</p>
      </div>
      <ul class="ul">
        <li>
          <!-- <div class="icon" v-bind:style="{background:'url(' + icon_img1 + ') no-repeat center',backgroundSize:'2.4rem 2.9rem;'}"></div> -->
          <img class="icon" :src="icon_img1" />
          <h3>公司地址</h3> 
          <P>北京市朝阳区东三环北路丙2号天元港中心B座1006</P>
        </li>
        <li>
          <!-- <div class="icon" v-bind:style="{background:'url(' + icon_img2 + ') no-repeat center'}" style="background-size:3.2rem 2.6rem"></div> -->
          <img class="icon" :src="icon_img2" />
          <h3>联系电话</h3>
          <P>+86（0）10 84185298</P>
        </li>
        <li>
          <!-- <div class="icon" v-bind:style="{background:'url(' + icon_img3 + ') no-repeat center'}" style="background-size:3rem 2.3rem"></div> -->
          <img class="icon" :src="icon_img3" />
          <h3>电子邮箱</h3>
          <P>info@hanlandglobal.com</P>
        </li>
      </ul>
    </div>
    <div class="main-bottom">
        <ul class="content-container">
          <li class="li-1">
            <div class="code icon-code"></div>
            <div>
              <h3>汉伦投资</h3>
              <span></span>
              <p>房源所见即所得</p>
            </div>
          </li>
          <li class="li-2">
           <div class="code icon-code2" ></div>
            <div>
              <h3>汉伦物业管理</h3>
              <span></span>
              <p>做省心洋房东</p>
            </div>
          </li>
          <li class="li-3">
            <div class="code icon-code3"></div>
            <div>
              <h3>汉伦租赁</h3>
              <span></span>
              <p>管家式服务只为您来</p>
            </div>
          </li>
          <li class="li-4">
            <div class="code icon-code4"></div>
            <div>
              <h3>家具与报税</h3>
              <span></span>
              <p>开启无忧投资后时代</p>
            </div>
          </li>
          <li class="li-5">
            <div class="code icon-code5"></div>
            <div>
              <h3>汉伦uk公众号</h3>
              <span></span>
              <p>英国最新咨询尽在掌握</p>
            </div>
          </li>
          <li class="li-6">
            <div class="code icon-code6"></div>
            <div>
              <h3>汉伦管家微博</h3>
              <span></span>
              <p>超多优惠用户直达</p>
            </div>
          </li>
        </ul>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import SideBarComponent from '@components/SideBarComponent'

import icon_img1 from '@assets/image/about/icon_img1.png'
import icon_img2 from '@assets/image/about/icon_img2.png'
import icon_img3 from '@assets/image/about/icon_img3.png'

  export default {
    name: 'ContactUs',
    computed:{

    },
    components: {
        FooterComponent,
        NavComponent,
        SideBarComponent,
    },
    data() {
      return {
        icon_img1,icon_img2,icon_img3
      }
    },
    mounted(){

    },
    methods:{
      codeShow(){
      },
    }
    
  };
</script>

<style lang="scss" scoped>
.banner{
    width: 100%;
    height: 20.8rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 20.8rem;  
}
.contact{
  margin:5rem auto 2.5rem;
}
.title{
  text-align: center;
  position: relative;
  h3{
    width: 100%;
    font-size: 1.5rem;
    color: $color;
    font-weight: 700;
    position: absolute;
    z-index: 100;
    top:0.1rem;
  }
  p{
    font-size: 2.4rem;
    color: #ecedee;
    line-height: 4rem;
    font-weight: 700;
  }
}
.ul{
  display: flex;
  justify-content:space-around;
  margin-top:1rem;
  text-align: center;
  li{
    width: 14.3rem;
    height: 14.5rem;
    border: solid 2px #e3e7ec;
    h3{
      color: #3a4a5b;
      font-size: 1rem;
      font-weight: 700;
    }
    p{
      width: 10.9rem;
      margin: 0 auto;
      font-size: 0.8rem;
      color: #3a4a5b;
      line-height: 1.2rem;
      margin-top:0.8rem;
    }
  }
  .icon{
    width: auto;
    height: auto;
    margin: 2.5rem auto 1rem;
  }
}
.main-bottom{
  width: 100%;
  height: 20.8rem;
  background-color: #f5f5f5;
  ul{
    display: flex;
    justify-content:space-between;
    flex-wrap: wrap;
    li{
      display:flex;
      margin:2.3rem 0 0;
      transform-style: preserve-3d;
      -webkit-perspective: 800;
      -webkit-transition: all 1.5s;
      -moz-transition: all 1.5s;
      -ms-transition: all 1.5s;
      -o-transition: all 1.5s;
      -moz-perspective: 800;
      -ms-perspective: 800;
      perspective: 800;
      .code{
        width: 6rem;
        height: 6rem;
        transition: 1s;
      }
      .icon-code{
        background: url('../assets/image/about/icon_img4.png') no-repeat center;
        background-size:5.4rem 5.4rem;
      }
      .icon-code2{
        background: url('../assets/image/about/icon_img5.png') no-repeat center;
        background-size:5.45rem 5.2rem;
      }
      .icon-code3{
        background: url('../assets/image/about/icon_img6.png') no-repeat center;
        background-size:5.5rem 5.2rem;
      }
      .icon-code4{
        background: url('../assets/image/about/icon_img7.png') no-repeat center;
        background-size:5.2rem 5.4rem;
      }
      .icon-code5{
        background: url('../assets/image/about/icon_img8.png') no-repeat center;
        background-size:5.4rem 5.4rem;
      } 
      .icon-code6{
        background: url('../assets/image/about/icon_img9.png') no-repeat center;
        background-size:5.4rem 5.4rem;
      }
      span{
        display:block;
        width: 7.2rem;
        border: solid 1px #b3b3b3;
      }
      div{
          margin-left: 1rem;
        h3{
          font-size: 1rem;
          line-height: 2rem;
          color: $color;
        }
        p{
          color: #3a4a5b;
          font-size: 0.8rem;
          margin-top: 0.6rem;
        }
      }
    }
    .li-1:hover{
      .icon-code{
        background: url('../assets/image/about/hanland_img.jpg') no-repeat center;
        transform: rotateY(180deg);
        background-size: 6rem 6rem;
      }
    }
    .li-2:hover{
      .icon-code2{
        background: url('../assets/image/about/wuye_img.jpg') no-repeat center;
        transform: rotateY(180deg);
        background-size: 6rem 6rem;        
      }
    }
    .li-3:hover{
      .icon-code3{
        background: url('../assets/image/about/zhufang_img.jpg') no-repeat center;
        transform: rotateY(180deg);
        background-size: 6rem 6rem;        
      }
    }
    .li-4:hover{
      .icon-code4{
        background: url('../assets/image/about/touzi_img.jpg') no-repeat center;
        transform: rotateY(180deg);
        background-size: 6rem 6rem;        
      }
    }
    .li-5:hover{
      .icon-code5{
        background: url('../assets/image/about/uk_img.jpg') no-repeat center;
        transform: rotateY(180deg);
        background-size: 6rem 6rem;        
      }
    }
    .li-6:hover{
      .icon-code6{
        background: url('../assets/image/about/weibo_img.jpg') no-repeat center;
        transform: rotateY(180deg);
        background-size: 6rem 6rem;        
      }
    }
  }
}
@media only screen and (max-width: 1024px){
  .banner{
    height: 18.8rem;
    background-size:cover;
  }
  .contact{
    padding: 0 3%;
  }
  .ul{
    .icon{
      width: 2.5rem;
      height: auto;
      margin: 1.2rem auto 0.6rem;
    }
    li{
      width: 28%;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content:space-around;
      p{
        width: 94%;
        margin-bottom:0.6rem
      }
    }
  }
  .main-bottom{
    height: 28.8rem;
    ul{
      display: flex;
      justify-content:space-around;
      li{
        flex:0.4;
        div{
          margin-left: 0;
        }
      }
    }
  }
}
</style>